import React from 'react';

// Line-art icon set. One consistent 24×24 grid, 1.4px stroke, round caps and
// joins — drawn rather than picked, so the set reads as a family instead of a
// bag of emoji. Colour comes from `currentColor`.

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: 'false',
};

/* ---- Services ----------------------------------------------------------- */

// Browser frame with a data bar — websites and information systems.
export const IconSystems = (props) => (
  <svg {...base} {...props}>
    <rect x="2.5" y="4" width="19" height="16" rx="2.5" />
    <path d="M2.5 8.5h19" />
    <circle cx="5.6" cy="6.25" r="0.65" fill="currentColor" stroke="none" />
    <circle cx="7.9" cy="6.25" r="0.65" fill="currentColor" stroke="none" />
    <path d="M6.5 16.8v-3.4M10 16.8v-5.2M13.5 16.8v-2.1M17 16.8v-4.3" />
  </svg>
);

// Aperture-style play mark — video production.
export const IconVideo = (props) => (
  <svg {...base} {...props}>
    <rect x="2.5" y="5" width="13.5" height="14" rx="2.5" />
    <path d="M16 10.5l5-2.6v8.2l-5-2.6z" />
    <path d="M7 12.5l3.2-1.9v3.8z" />
  </svg>
);

// Bezier handle on a curve — graphic design.
export const IconDesign = (props) => (
  <svg {...base} {...props}>
    <path d="M3.5 18.5c6.5 0 7.5-13 17-13" />
    <rect x="2" y="17" width="3" height="3" rx="0.8" />
    <rect x="19" y="4" width="3" height="3" rx="0.8" />
    <path d="M9.5 12.2l4.6 4.6M14.1 12.2l-4.6 4.6" opacity="0.45" />
  </svg>
);

// Broadcast arcs from a node — social media.
export const IconSocial = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="2.4" />
    <path d="M7.8 7.8a6 6 0 000 8.4M16.2 16.2a6 6 0 000-8.4" />
    <path d="M4.9 4.9a10 10 0 000 14.2M19.1 19.1a10 10 0 000-14.2" opacity="0.5" />
  </svg>
);

/* ---- Differentiators ---------------------------------------------------- */

// Four-point spark — fresh ideas.
export const IconSpark = (props) => (
  <svg {...base} {...props}>
    <path d="M12 3.2l1.9 5.6 5.6 1.9-5.6 1.9L12 18.2l-1.9-5.6-5.6-1.9 5.6-1.9z" />
    <path d="M18.8 15.6l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" opacity="0.55" />
  </svg>
);

// Map pin with a horizon line — local roots.
export const IconPin = (props) => (
  <svg {...base} {...props}>
    <path d="M12 21s6.4-5.6 6.4-10.2A6.4 6.4 0 105.6 10.8C5.6 15.4 12 21 12 21z" />
    <circle cx="12" cy="10.6" r="2.3" />
  </svg>
);

// Adjustable sliders — tailored solutions.
export const IconTuning = (props) => (
  <svg {...base} {...props}>
    <path d="M5 4v6M5 14v6M12 4v10M12 18v2M19 4v2M19 10v10" />
    <circle cx="5" cy="12" r="1.9" />
    <circle cx="12" cy="16" r="1.9" />
    <circle cx="19" cy="8" r="1.9" />
  </svg>
);

// Upward step chart — real results.
export const IconResults = (props) => (
  <svg {...base} {...props}>
    <path d="M3.5 19.5h17" />
    <path d="M6.5 16.5v-3.8M11 16.5V8.4M15.5 16.5v-6.2M20 16.5V4.8" />
    <path d="M6.5 12.7l4.5-4.3 4.5 1.9L20 4.8" opacity="0.45" />
  </svg>
);

/* ---- Utility ------------------------------------------------------------ */

export const IconArrowRight = (props) => (
  <svg {...base} {...props}>
    <path d="M4.5 12h15M13.5 6l6 6-6 6" />
  </svg>
);

export const IconArrowDown = (props) => (
  <svg {...base} {...props}>
    <path d="M12 4.5v15M6 13.5l6 6 6-6" />
  </svg>
);

export const IconCheck = (props) => (
  <svg {...base} {...props}>
    <path d="M4.5 12.5l5 5 10-11" />
  </svg>
);

export const IconExternal = (props) => (
  <svg {...base} {...props}>
    <path d="M14 4.5h5.5V10" />
    <path d="M19.5 4.5L11 13" />
    <path d="M18 14.5v4a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 014 18.5v-11A1.5 1.5 0 015.5 6h4" />
  </svg>
);
